import { Avatar, Col, Dropdown, Layout, Menu, notification, Row } from "antd"
import React, { useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import STORAGE, {
  clearStorage,
  clearStorageCookie,
  getStorage,
  getStorageCookie,
  setStorage,
} from "src/lib/storage"
import { StoreContext } from "src/lib/store"
import UseWindowSize from "src/lib/useWindowSize"
import { hasPermission, isMobileConst } from "src/lib/utils"
import ModalChangeInfo from "src/pages/USER/MyAccount/components/ModalChangeInfo"
import ROUTER from "src/router"
import AuthService from "src/services/AuthService"
import LayoutCommon from "../Common/Layout"
import LayoutAdminCommon from "../Common/LayoutAdmin"
import ModalLogout from "../Modal/Logout"
import SvgIcon from "../SvgIcon"
import { MenuItemAdmin } from "./MenuItems"
import LayoutAdmin from "./component/LayoutAdmin"
import Notification from "./component/Notification"
import { LayoutStyled, StyleMenuAccount } from "./styled"
import "./styles.scss"
import TopRate from "./component/TopRate"
import { ZenifyApp } from "../../initZenify"
import logo from "src/assets/images/logo/logonew.png"
import ModalAuth from "./component/ModalAuth"
import { clearCart } from "src/redux/cartSlice"
import LuxurySwitch from "../LuxurySwitch"

const { Header, Content } = Layout

const MainLayout = ({ children, isAdmin }) => {
  const { listTabs, userInfo } = useSelector(state => state?.appGlobal)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const isLogin = getStorageCookie(STORAGE.TOKEN)
  const isTime = getStorage(STORAGE.EXP_TIME)
  // const isInfo = getStorage(STORAGE.USER_INFO)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [selectedKey, setSelectedKey] = useState(
    getStorage(STORAGE.KEY_MENU_ACTIVE) || ["/"],
  )
  const [openUserInfor, setOpenUserInfor] = useState(false)
  const { isNotificationUpdate } = useContext(StoreContext)
  const [isModelNotification, setIsModelNotification] = isNotificationUpdate
  const currentTime = Date.now()
  const [selectedKeyAdmin, setSelectedKeyAdmin] = useState()
  const [openLogout, setOpenLogout] = useState(false)
  const [showAuthModal, setShowAuthModal] = useState(false)
  // let isManagerPage = location.pathname.includes(ROUTER.QUAN_LY_TAI_KHOAN)
  const role = localStorage.getItem(STORAGE.ROLES)
  let isManagerPage = false
  useEffect(() => {
    let key = location?.pathname
    // console.log('location', location);
    setSelectedKey([key])
    setSelectedKeyAdmin([key])
  }, [location])
  useEffect(() => {
    if (!!isTime && isTime < currentTime) {
      handleLogout()
    }
  }, [isTime, currentTime])
  const onClickMenu = key => {
    if (isModelNotification) {
      setIsModelNotification(false)
    }
    setStorage(STORAGE.KEY_MENU_ACTIVE, key.keyPath)
    setSelectedKey(key.key.keyPath)
    if (!key.key.includes("subkey")) navigate(key.key)
  }
  const handleLogout = async () => {
    try {
      if (isLogin) {
        let res = await AuthService.logout()
        clearStorage()
        clearStorageCookie()
        dispatch(clearCart())
        // ZenifyApp.logout()
        return navigate(ROUTER?.HOME_PAGE_CUSTOMER)
      }
    } catch (error) {
      clearStorageCookie()
      clearStorage()
      dispatch(clearCart())
      return navigate(ROUTER?.HOME_PAGE_CUSTOMER)
    }
  }

  const menuAccount = (
    <StyleMenuAccount>
      <div className="menu-account">
        <Menu className="dropdown-option">
          <div className="account-infor">
            <Menu.Item
              key="3"
              onClick={() => {
                navigate(ROUTER.ACCOUNT)
                // setOpenUserInfor(true)
              }}
            >
              <div className="btn-function strok-btn-function">
                <SvgIcon name="user-info" />
                <span className="fw-400">Thông tin tài khoản</span>
              </div>
            </Menu.Item>
            {/* <Menu.Item
              key="4"
              // onClick={() => {
              //   navigate(ROUTER.DOI_MAT_KHAU)
              // }}
            >
              <div className="btn-function strok-btn-function">
                <SvgIcon name="reset-pass" />
                <span className="fw-400">Rút Tiền</span>
              </div>
            </Menu.Item> */}
            {/*{*/}
            {/*  // Sau có thời gian chỉ sẽ đưa hết vào bộ config*/}
            {/*    permissions?.includes('permission.list') && (*/}
            {/*        <Menu.Item*/}
            {/*            key="3"*/}
            {/*            onClick={() => {*/}
            {/*              navigate(ROUTER.SETTING_PERMISSIONS)*/}
            {/*              // notification.info({*/}
            {/*              //   placement: 'top',*/}
            {/*              //   message: 'Thông báo',*/}
            {/*              //   description: 'Chức năng đang phát triển!',*/}
            {/*              //   duration: 1.5*/}
            {/*              // });*/}
            {/*            }}*/}
            {/*        >*/}
            {/*          <div className="btn-function strok-btn-function">*/}
            {/*            <SvgIcon name="user-info" />*/}
            {/*            <span className="fw-400">Quản trị hệ thống</span>*/}
            {/*          </div>*/}
            {/*        </Menu.Item>*/}
            {/*    )*/}
            {/*}*/}
            <Menu.Item
              key="5"
              style={{ color: "#ED1117" }}
              onClick={() => setOpenLogout(true)}
            >
              <div className="btn-logout">
                <SvgIcon name="logoutIcon" />
                Đăng xuất
              </div>
            </Menu.Item>
          </div>
        </Menu>
      </div>
    </StyleMenuAccount>
  )

  const setShowListMenu = list =>
    !!list?.length
      ? list
          ?.filter(
            x => hasPermission(x?.TabID, [...listTabs]) || x.publishRouter,
          )
          .map(i => ({
            ...i,
            children: setShowListMenu(i?.children),
          }))
      : undefined

  // if (isMobileConst) {
  //   return <LayoutMobile>{children}</LayoutMobile>
  // }

  return (
    <>
      <LayoutStyled styleBackground={isManagerPage}>
        {/* css ẩn menu đi */}
        {/* {isLogin && ( */}
        <Header className={`header-background`}>
          <div className="d-flex-start">
            <div className="w-100">
              {React.createElement(isAdmin ? LayoutAdminCommon : LayoutCommon, {
                children: (
                  <Row
                    gutter={10}
                    className="pt-5 pb-5 px-3 d-flex align-items-center justify-content-space-between"
                  >
                    <Col
                      className={`d-flex-center justify-content-flex-start nowrap`}
                    >
                      <div
                        style={{ cursor: "pointer" }}
                        className={"mr-40 ml-10"}
                        onClick={() => {
                          return isLogin
                            ? navigate(ROUTER.HOME_PAGE)
                            : navigate(ROUTER.HOME_PAGE_CUSTOMER)
                        }}
                      >
                        <div
                          className="logo-login"
                          style={{ textAlign: "center" }}
                        >
                          <img
                            src={logo || ""}
                            alt="WSM Logo"
                            style={{
                              width: "auto",
                              height: 60,
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={0} lg={12}>
                      <TopRate />
                    </Col>
                    <Col style={{ width: "auto" }}>
                      <Row
                        gutter={30}
                        className="align-items-center layout-action"
                      >
                        {!!isLogin ? (
                          <div
                            className="d-flex justify-content-flex-end align-items-center"
                            style={{ margin: "1vw" }}
                          >
                            {!!isLogin && (role === "ADMIN" || role === "CUSTOMER") && <LuxurySwitch />}
                            {/* thông báo */}
                            {/* <Notification /> */}
                            <span
                              className="mr-4 max-line1"
                              style={{
                                maxWidth: "calc(100vw - 1428px)",
                                display: "block",
                                color: "white",
                              }}
                              title={userInfo?.fullname}
                            >
                              {userInfo?.fullname}
                            </span>
                            <Dropdown
                              overlay={menuAccount}
                              overlayStyle={{ minWidth: "200px" }}
                            >
                              <Row gutter={5} className="pointer ">
                                <Col>
                                  <div className="account-infor-avatar">
                                    <Avatar
                                      src={userInfo?.avatar_url}
                                      size={38}
                                      className="style-avt mr-2"
                                      icon={
                                        <div>
                                          {!!userInfo?.avatar_url ? (
                                            <img
                                              style={{ width: "40px" }}
                                              className="back-ground-img"
                                              src={userInfo?.avatar_url}
                                            />
                                          ) : (
                                            <SvgIcon name="user-circle" />
                                          )}
                                        </div>
                                      }
                                    />

                                    <SvgIcon name="arrow-down-primary" />
                                  </div>
                                </Col>
                              </Row>
                            </Dropdown>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center h-100 ">
                            <Row
                              // onClick={() => navigate(ROUTER.DANG_NHAP)}
                              onClick={() => setShowAuthModal("login")}
                              className="align-items-center pointer login-item"
                            >
                              <span className="login-item_text">Đăng nhập</span>
                            </Row>
                            <Row
                              // onClick={() => navigate(ROUTER.DANG_KY)}
                              onClick={() => setShowAuthModal("register")}
                              className="align-items-center pointer login-item"
                            >
                              <span className="login-item_text">Đăng ký</span>
                            </Row>
                          </div>
                        )}
                      </Row>
                    </Col>
                  </Row>
                ),
              })}
            </div>
          </div>
          <ModalLogout
            openLogout={openLogout}
            setOpenLogout={setOpenLogout}
            handleLogout={handleLogout}
          />
        </Header>
        {/* )} */}

        <Layout>
          <Row className="admin-style">
            {!!isAdmin ? (
              <>
                <LayoutAdmin
                  children={children}
                  menuAdmin={MenuItemAdmin().filter(i => i.publishRouter)}
                  selectedKey={selectedKeyAdmin}
                />
              </>
            ) : (
              <Content className="site-layout-background w-100">
                <div
                  className="w-100"
                  style={{ minHeight: "calc(100vh - 105px)" }}
                >
                  <LayoutCommon>{children}</LayoutCommon>
                </div>
              </Content>
            )}
          </Row>
        </Layout>
        {!!openUserInfor && (
          <>
            <ModalChangeInfo
              open={openUserInfor}
              userInfo={userInfo}
              onCancel={() => setOpenUserInfor(false)}
              onOk={() => {}}
            />
          </>
        )}
        {showAuthModal && (
          <ModalAuth
            visible={showAuthModal}
            onClose={() => setShowAuthModal(false)}
          />
        )}
      </LayoutStyled>
    </>
  )
}

export default React.memo(MainLayout)
